import { defaultSortOrder } from '../constants/sortOrders'
import changeSortOrder from './changeSortOrder'

const getSortOrder = (curSortBy, newSortBy, curSortOrder) => {
    let newSortOrder = defaultSortOrder

    if (curSortBy === newSortBy) {
        newSortOrder = changeSortOrder(curSortOrder)
    }

    return newSortOrder
}

export default getSortOrder
